export function offerState(v) {
  const cents = Number(v.price);
  const price = new Intl.NumberFormat('fr-FR', {style:'currency',currency:'EUR',minimumFractionDigits:cents%100?2:0,maximumFractionDigits:2}).format(cents/100);
  const status = !v.available ? 'Indisponible' : !v.managed ? 'Disponibilité à confirmer' : Number(v.quantity)>0 ? 'En stock' : 'Sur commande';
  const colorLabel = (!v.color || v.color === 'Default Title') ? '' : ' · ' + v.color;
  return {price,status,label:status + colorLabel};
}

if (typeof window !== 'undefined' && !customElements.get('kb-product-offer')) {
  class KBProductOffer extends HTMLElement {
    connectedCallback() {
      this.formScope = this.closest('[data-ref="product-section-content"]')?.querySelector('[data-ref="product-form"]');
      this.render();
      this.onVariant = (e) => {
        const updated = e.detail?.data?.html?.querySelector('kb-product-offer');
        if (updated) {
          for (const key of ['price','available','managed','quantity','color','variantId']) this.dataset[key] = updated.dataset[key];
          this.render();
        }
      };
      this.formScope?.addEventListener('variant:updated', this.onVariant);
    }
    disconnectedCallback(){ this.formScope?.removeEventListener('variant:updated', this.onVariant); }
    render(){
      const state = offerState({price:this.dataset.price, available:this.dataset.available==='true', managed:this.dataset.managed==='true', quantity:this.dataset.quantity, color:this.dataset.color});
      this.querySelector('[data-lb1-price]').textContent = state.price;
      this.querySelector('[data-lb1-status]').textContent = state.label;
    }
  }
  customElements.define('kb-product-offer', KBProductOffer);
}
